var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { SpinnerIcon } from '../../icons';
import { Typography } from '../../Typography';
import { KINDS, SIZES, STATES } from '../Button.constants';
import { ButtonTestIdFactory } from '../interactions';
import { ICON_SIZE_MAPPER, KIND_STATE_CLASS_MAP, LINE_HEIGHT_CLASS_MAP, SIZE_CLASS_MAP, } from '../mappers';
import styles from '../styles/Button.module.css';
export const Button = ({ 'aria-describedby': ariaDescribedBy, 'aria-label': ariaLabel, children, className, 'data-test-state': testState, 'data-testid': testid, disabled = false, EndIcon = undefined, isFullWidth = false, isLoading = false, kind = KINDS.Primary, onBlur, onFocus, ref, size = SIZES.Medium, StartIcon = undefined, type = 'button', ...restButtonProps }) => {
    let state;
    if (isLoading) {
        state = STATES.Loading;
    }
    else if (disabled) {
        state = STATES.Disabled;
    }
    else {
        state = STATES.Enabled;
    }
    // Remove padding for ghost/ghost-danger/link (Figma)
    const hasNoPadding = kind === KINDS.Ghost ||
        kind === KINDS.GhostDanger ||
        kind === KINDS.Link;
    // isInvisibleClass maintain button width when component goes into loading state
    const isInvisibleClass = C(isLoading && styles.Invisible);
    const buttonClassName = C(styles.Base, !isFullWidth ? styles.BaseInline : styles.BaseFlex, !disabled ? styles.BaseEnabled : styles.BaseDisabled, SIZE_CLASS_MAP[size], KIND_STATE_CLASS_MAP[kind][state], isLoading && styles.Loading, className, hasNoPadding && styles.NoPadding);
    return (_jsxs("button", { ...(ariaDescribedBy && {
            'aria-describedby': ariaDescribedBy,
        }), ...(ariaLabel && { 'aria-label': ariaLabel }), ...(isLoading && { 'aria-busy': true }), className: buttonClassName, "data-test-state": testState, "data-testid": ButtonTestIdFactory.getButtonTestId(testid), disabled: disabled || isLoading, onBlur: onBlur, onFocus: onFocus, ref: ref, type: type, ...restButtonProps, children: [isLoading && (_jsx(SpinnerIcon, { className: styles.LoadingIcon, color: "accent", size: ICON_SIZE_MAPPER[size] })), StartIcon ? (_jsx(StartIcon, { className: isInvisibleClass, size: ICON_SIZE_MAPPER[size] })) : null, children ? (_jsx(Typography, { className: C(isInvisibleClass, LINE_HEIGHT_CLASS_MAP[size]), color: "inherit", "data-testid": ButtonTestIdFactory.getButtonTextTestId(testid), fontWeight: size === 'small' ? 'medium' : 'bold', 
                // Link Button kind should look exactly like the Subtle link
                // It has small, bold text and 20x20px icon
                kind: size === 'small' || kind === KINDS.Link
                    ? 'generic-small'
                    : 'generic', children: children })) : null, EndIcon ? (_jsx(EndIcon, { className: isInvisibleClass, size: ICON_SIZE_MAPPER[size] })) : null] }));
};
_react_refresh_temp_1 = Button;
$RefreshReg$(_react_refresh_temp_1, "Button");
